/**
 * Created by youzipi on 17/8/11.
 */
export default {
  // namespaced: true,
  state: {
    headerCategories: [
      {
        name: '首页',
        href: '/ArticleHome'
      },
      {
        id: 1,
        name: '创业资讯',
        href: '/articles/list'
      },
      {
        id: 2,
        name: '财务干货',
        href: '/articles/list'
      },
      {
        id: 3,
        name: '法律干货',
        href: '/articles/list'
      },
      {
        id: 4,
        name: '人事干货',
        href: '/articles/list'
      },
      {
        id: 5,
        name: '工商干货',
        href: '/articles/list'
      },
    ],
  },

  getters: {
    getHeaderCategories(state){
      return state.headerCategories
    },

    getHeaderCategoriesMap(state){
      let map = {};
      state.headerCategories.forEach(item => {
        if (item.id !== undefined && item.id !== null){
          let key  = item.id + '';
          map[key] = item.name;
        }
      })
      return map;
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/module/article.js